import { Button, Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { placeholder } from 'src/styles/mixins';
import { spacing1, spacing10, spacing4, spacing7, spacing8 } from 'src/styles/spacing';

export const StyledContainer = styled(Container)`
  margin-top: ${spacing8};
  margin-bottom: ${spacing10};
`;

export const StyledHeading = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing8};
  }
`;

export const StyledSuccessItems = styled.div`
  margin-bottom: ${spacing7};
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  padding-bottom: ${spacing1};
`;

export const StyledButton = styled(Button)`
  margin: 0 auto;
`;

export const StyledHeadingPlaceholder = styled.div`
  ${placeholder};
  height: 48px;
  max-width: 554px;
  margin: 0 auto ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    margin: 0 auto ${spacing8};
  }
`;
